/** 售后二维码 PRO 配置项帮助文档 */
export const QR_PRO_HELP = {
  // ── 页面基本信息 ──
  page_name: {
    title: '页面名称',
    purpose: '在管理后台标识此售后落地页，方便区分不同产品或活动。',
    usage: '填写便于识别的名称，如「产品A-美国站售后页」。仅内部可见，买家看不到。',
  },
  amazon_asin: {
    title: 'Amazon ASIN',
    purpose: '关联亚马逊产品 ASIN，用于快速生成留评链接及邮件变量 {{asin}}。',
    usage: '填写 10 位 ASIN，如 B08XXXXXXX。填写后可点击「留评链接」旁的「快速生成」自动拼接亚马逊留评 URL。',
  },
  review_link: {
    title: '留评链接',
    purpose: '买家在第二页给出 5 星好评后，引导其跳转的亚马逊留评地址。',
    usage: '可手动粘贴，或根据 ASIN 点击「快速生成」。链接会出现在建联成功邮件的 {{review_link}} 变量及第二页评星模块中。',
    tips: '建议链接到对应 ASIN 的 5 星留评页，提升留评转化率。',
  },
  verification_code: {
    title: '验证码',
    purpose: '买家通过邮件回复此验证码，系统识别后完成建联并解锁第二页。',
    usage: '设置一个简短易记的字符串（如 1688）。买家提交订阅后，系统会引导其向客服邮箱发送包含此验证码的邮件；后台扫描收件箱匹配成功后标记为已验证。',
    tips: '建议使用数字或字母组合，避免特殊字符导致邮件客户端解析异常。',
  },
  sender_email_account: {
    title: '客服邮箱',
    purpose: '用于发送验证邮件、建联成功邮件，以及接收买家回复的验证码。',
    usage: '从已绑定的邮箱账号中选择一个。需确保该邮箱已接入系统并能正常收发邮件。',
    tips: '此邮箱也是「邮件联系」按钮和「自动打开邮箱 App」功能的目标地址，务必提前配置好。',
  },
  customer_group: {
    title: '客户分组',
    purpose: '订阅成功的买家自动归入指定客户分组，便于 CRM 管理。',
    usage: '从客户分组列表中选择。留空则使用系统默认分组「二维码PRO客户」。',
  },
  customer_source: {
    title: '客户来源',
    purpose: '同步到客户管理模块时的来源标识，用于统计渠道效果。',
    usage: '填写来源名称，如「售后二维码PRO」。会写入客户档案的来源字段。',
  },
  allow_duplicate_subscribe: {
    title: '允许重复订阅',
    purpose: '控制同一邮箱是否可以多次提交订阅表单。',
    usage: '开启：同一邮箱可多次提交（适用于补发、多批次等场景）。关闭：同一邮箱仅允许订阅一次，重复提交显示「重复订阅提示」。',
  },
  auto_redirect_page2: {
    title: '自动跳转第二页',
    purpose: '控制买家验证码被后台识别后，第一页是否自动跳转到第二页（评星/留评页）。',
    usage: '开启：后台扫到验证码后，买家再次打开第一页链接会自动跳转第二页。关闭：买家需点击建联成功邮件中的激活链接进入第二页。',
    tips: '开启可提升用户体验，减少操作步骤；关闭则给买家更多控制权。',
  },
  auto_tags: {
    title: '自动标签',
    purpose: '买家订阅提交时，自动为其打上指定标签，便于后续筛选和营销。',
    usage: '输入标签名后按回车添加。支持从已有标签中选择。订阅成功后会自动应用这些标签。',
  },
  custom_domain: {
    title: '自定义域名',
    purpose: '用您的品牌域名（如 review.yourbrand.com）替代系统默认域名，提升买家信任感。',
    usage: '点击「绑定域名」，按向导完成 DNS CNAME 解析、域名验证和 SSL 证书申请。配置成功后，批次二维码链接将使用您的域名。',
    tips: 'DNS 解析通常需 5–30 分钟生效，验证失败请稍后重试。',
  },
  domain_address: {
    title: '域名地址',
    purpose: '要绑定的完整子域名，用于品牌化的落地页访问地址。',
    usage: '填写完整域名，如 review.yourbrand.com。然后在 DNS 服务商添加 CNAME 记录指向 apis.bubu.im。',
  },

  // ── 风控管理 ──
  china_detect_enabled: {
    title: '是否检测中国',
    purpose: '总开关：是否对访客进行中国地区识别，以执行差异化策略。',
    usage: '开启后，下方检测方法生效；检测到中国访客时，按「检测到中国后」的配置处理。关闭则所有访客走正常落地页流程。',
    tips: '适用于主要面向海外市场的售后场景，可对国内访客展示不同内容或跳过邮件/入库。',
  },
  china_detect_by_language: {
    title: '浏览器语言 (zh)',
    purpose: '通过 HTTP Accept-Language 头检测访客浏览器是否设置为中文。',
    usage: '开启后，浏览器语言包含 zh（如 zh-CN、zh-TW）即判定为中国访客。',
  },
  china_detect_by_ip: {
    title: 'IP 国家 (CN)',
    purpose: '通过访客 IP 地址解析国家，判断是否为中国大陆。',
    usage: '开启后，IP 归属国家为 CN 即判定为中国访客。基于本地 GeoIP 数据库解析。',
  },
  china_detect_by_timezone: {
    title: '时区 (Asia/Shanghai)',
    purpose: '检测访客设备时区是否为东八区（上海）。',
    usage: '开启后，时区为 Asia/Shanghai 即参与中国判定。',
  },
  china_detect_by_ua: {
    title: '国产浏览器',
    purpose: '通过 User-Agent 识别微信、QQ、UC、夸克等国产浏览器内置 WebView。',
    usage: '开启后，UA 匹配国产浏览器特征即参与中国判定。适用于微信扫码等场景。',
  },
  china_detect_by_utc_offset: {
    title: '时区偏移 (UTC+8)',
    purpose: '前端 JavaScript 检测设备 UTC 偏移是否为 +8 小时。',
    usage: '开启后，设备时区偏移为 UTC+8 即参与中国判定。与「时区 Asia/Shanghai」互补。',
  },
  china_detect_by_nav_languages: {
    title: '语言列表含 zh',
    purpose: '前端检测 navigator.languages 是否包含中文语言代码。',
    usage: '开启后，浏览器语言偏好列表含 zh 即参与中国判定。',
  },
  china_detect_by_fonts: {
    title: '中文字体',
    purpose: '前端检测系统是否安装了宋体、微软雅黑等中文字体。',
    usage: '开启后，检测到中文字体即参与中国判定。对海外华人设备可能产生误判。',
  },
  china_detect_by_connectivity: {
    title: '网络连通性探测',
    purpose: '探测访客能否访问墙外资源，作为辅助判定手段。',
    usage: '开启后，若无法访问指定境外资源则参与中国判定。检测最强但可能有延迟，防火墙用户可能被误伤。',
    tips: '建议作为最后一道补充检测，不宜单独依赖。',
  },
  send_email_to_china: {
    title: '是否发送邮件',
    purpose: '检测到中国访客后，是否仍向其发送验证/建联邮件。',
    usage: '关闭：中国访客订阅后不发送邮件。开启：可配置专属邮件主题和正文，留空则使用默认建联成功邮件。',
  },
  china_email_subject: {
    title: '单独邮件主题',
    purpose: '中国访客收到的邮件主题，与海外访客区分。',
    usage: '留空则使用建联成功邮件的默认主题。支持 {name} 等占位符。',
  },
  china_email_body: {
    title: '单独邮件正文',
    purpose: '中国访客收到的邮件 HTML 正文。',
    usage: '留空则使用建联成功邮件默认正文。支持 {name} 占位符，可填写纯文本或 HTML。',
  },
  china_ingest: {
    title: '是否入库',
    purpose: '检测到中国访客订阅后，是否写入客户库。',
    usage: '关闭：中国访客数据不入库，仅记录订阅日志。开启：正常同步到客户管理。',
  },
  china_html_enabled: {
    title: '是否展示中国专属 HTML',
    purpose: '命中中国检测后，用自定义 HTML 整页替换正常落地页。',
    usage: '开启并填写下方 HTML 后，中国访客将看到专属页面，跳过模块渲染。管理端预览不受影响。',
  },
  china_html: {
    title: '中国专属 HTML',
    purpose: '中国访客看到的完整页面内容。',
    usage: '支持完整 <html> 文档或页面片段。可放置备案信息、国内联系方式或引导至其他渠道。',
    tips: '留空且开关开启时，访客可能看到空白页，请务必填写内容。',
  },

  // ── 批次 ──
  batch_name: {
    title: '批次名称',
    purpose: '区分同一页面下不同发货批次，每批次有独立二维码和内容配置。',
    usage: '建议按发货时间或渠道命名，如「2024年6月-第一批」。',
  },
  batch_shipment_quantity: {
    title: '发货数量',
    purpose: '记录本批次发货的产品数量，用于内部统计。',
    usage: '填写数字即可，不影响二维码功能，仅作备注统计。',
  },
  batch_notes: {
    title: '批次备注',
    purpose: '批次的补充说明信息，仅管理端可见。',
    usage: '可记录发货渠道、仓库、活动说明等，方便团队内部查阅。',
  },

  // ── 其他配置：外观 ──
  bg_color: {
    title: '页面背景色',
    purpose: '落地页整体背景颜色。',
    usage: '使用取色器或输入十六进制色值（如 #f0f2f5）。留空继承页面默认值。',
  },
  card_bg: {
    title: '卡片背景色',
    purpose: '内容卡片区域的背景颜色。',
    usage: '通常为白色 #ffffff。与页面背景色形成对比。',
  },
  top_border_color: {
    title: '顶部边框颜色',
    purpose: '卡片顶部装饰条的颜色，用于品牌色点缀。',
    usage: '默认蓝色 #2563eb，可改为品牌主色。',
  },
  top_border_height: {
    title: '顶部边框高度',
    purpose: '卡片顶部装饰条的粗细（像素）。',
    usage: '0 表示不显示，默认 4px。范围 0–20。',
  },
  card_radius: {
    title: '卡片圆角',
    purpose: '内容卡片四角的圆角半径。',
    usage: '0 为直角，数值越大越圆润。范围 0–40px。',
  },
  page_title: {
    title: '页面标题',
    purpose: '浏览器标签页显示的标题（第一页 SEO）。',
    usage: '留空使用默认文案。建议包含产品名或品牌名，有利于识别。',
  },

  // ── 其他配置：成功弹窗 ──
  success_title: {
    title: '成功标题',
    purpose: '买家提交订阅表单成功后，弹窗的标题文字。',
    usage: '按当前编辑语言填写。留空继承默认多语言文案。',
  },
  success_message: {
    title: '成功内容',
    purpose: '订阅成功弹窗的正文说明，引导买家下一步操作。',
    usage: '可提示买家查收邮件、回复验证码等。支持多行文本。',
  },
  duplicate_message: {
    title: '重复订阅提示',
    purpose: '同一邮箱重复提交且不允许重复订阅时显示的提示。',
    usage: '仅在「允许重复订阅」关闭时生效。可说明已订阅过、无需重复操作。',
  },

  // ── 其他配置：邮箱 App ──
  mail_app_countdown: {
    title: '倒计时文案',
    purpose: '开启「自动打开邮箱 App」后，弹窗中显示的倒计时提示。',
    usage: '可用变量：{{code}} 验证码、{{ref}} 识别码、{n} 秒数。例：「{n} 秒后自动打开邮箱…」',
  },
  mail_app_subject: {
    title: '邮箱主题（App 预填）',
    purpose: '自动打开邮箱 App 时预填的邮件主题。',
    usage: '可用 {{code}}、{{ref}}。买家只需发送即可，无需手动输入主题。',
  },
  mail_app_body: {
    title: '邮箱正文（App 预填）',
    purpose: '自动打开邮箱 App 时预填的邮件正文，通常包含验证码。',
    usage: '可用 {{code}}、{{ref}}。确保正文包含验证码，方便买家一键发送完成建联。',
  },

  // ── 其他配置：验证邮件 ──
  verification_subject: {
    title: '验证邮件主题',
    purpose: '买家订阅后收到的第一封验证邮件主题。',
    usage: '可用变量：{{name}} {{email}} {{code}} {{page_name}} {{batch_name}} {{asin}}。点击下方变量按钮可快速复制。',
  },
  verification_body: {
    title: '验证邮件正文',
    purpose: '验证邮件的 HTML 正文，引导买家回复验证码。',
    usage: '支持 HTML 标签。务必包含 {{code}} 及回复指引。变量与验证邮件主题相同。',
  },

  // ── 其他配置：建联成功邮件 ──
  success_subject: {
    title: '建联成功邮件主题',
    purpose: '验证码被识别、建联成功后发送的邮件主题。',
    usage: '可用变量含 {{activate_url}}（第二页链接）、{{review_link}} 等。',
  },
  success_body: {
    title: '建联成功邮件正文',
    purpose: '建联成功后的 HTML 邮件正文，含激活链接和留评引导。',
    usage: '建议包含 {{activate_url}} 引导进入第二页。5 星留评场景可加入 {{review_link}}。',
  },

  // ── 页面模块类型（模块介绍）──
  module_heading: {
    title: '标题模块',
    purpose: '在落地页展示醒目的标题文字，用于产品名、欢迎语或核心卖点。',
    usage: '适合放在页面顶部或重要内容前。可设置对齐方式和文字颜色，按当前语言分别编辑。',
    tips: '建议标题简短有力，1–2 行即可。',
  },
  module_text: {
    title: '段落文字模块',
    purpose: '展示多行说明文字，如产品介绍、使用指引、售后政策等。',
    usage: '支持多行文本和左/中/右对齐。可添加多个段落模块分段展示内容。',
  },
  module_image: {
    title: '图片模块',
    purpose: '在页面中插入产品图、说明图或品牌素材。',
    usage: '支持本地上传或填写图片 URL，可设置最大宽度、圆角和点击跳转链接。',
    tips: '建议压缩图片以加快手机端加载速度。',
  },
  module_banner: {
    title: '横幅大图模块',
    purpose: '全宽横幅展示，常用于页面顶部品牌图或活动海报。',
    usage: '上传横向比例图片（如 16:9），会以 cover 方式铺满宽度。可设置点击跳转链接。',
  },
  module_form: {
    title: '订阅表单模块',
    purpose: '第一页核心模块：收集买家姓名和邮箱，触发验证邮件与建联流程。',
    usage: '第一页默认包含且不可删除（至少保留一个）。可自定义占位符、按钮样式，以及「提交后自动打开邮箱 App」。',
    tips: '务必在页面信息中配置客服邮箱和验证码，表单才能正常完成建联。',
  },
  module_buttons: {
    title: '联系按钮模块',
    purpose: '提供邮件联系和 WhatsApp 快捷入口，方便买家主动联系客服。',
    usage: '可开启「邮件联系」按钮（自动填好客服邮箱和验证码）和 WhatsApp 按钮。样式可按批次、语言单独配置。',
    tips: '邮件按钮需先在页面信息配置客服邮箱；WhatsApp 号码格式为国家码+号码，如 8613800138000。',
  },
  module_video: {
    title: 'YouTube 视频模块',
    purpose: '在落地页嵌入 YouTube 视频，用于产品演示或使用教程。',
    usage: '粘贴 YouTube 链接（youtu.be 或 watch?v= 格式均可），页面会自动嵌入播放器。',
  },
  module_faq: {
    title: 'FAQ 问答模块',
    purpose: '展示常见问题与回答，减少买家疑虑、降低客服咨询量。',
    usage: '设置 FAQ 标题后，逐条添加「问题 + 回答」。按当前语言分别维护内容。',
  },
  module_richtext: {
    title: '富文本（卡片内）模块',
    purpose: '在卡片布局内插入自定义 HTML，实现更灵活的排版和样式。',
    usage: '在文本框中编写 HTML 片段，会渲染在页面卡片区域内。可使用 AI 提示词助手生成代码。',
    tips: '注意移动端适配，避免固定宽度过大的布局。',
  },
  module_richtext_full: {
    title: '自定义 HTML 模块',
    purpose: '整页直出自定义 HTML，完全接管页面内容区域的渲染。',
    usage: '适合已有完整页面代码、或需要高度定制设计的场景。添加后其他模块仍存在于列表，但此模块会整页输出 HTML。',
    tips: '与「富文本（卡片内）」不同，此模块不受卡片样式约束，间距设置也无效。',
  },
  module_social: {
    title: '社交媒体模块',
    purpose: '展示品牌社交媒体图标和链接，引导买家关注官方账号。',
    usage: '选择平台（Facebook、Instagram、X、YouTube 等）并填写主页 URL，可添加多条链接。',
  },
  module_divider: {
    title: '分割线模块',
    purpose: '用水平线分隔不同内容区块，让页面结构更清晰。',
    usage: '可调节线条粗细、颜色和样式（实线/虚线/点线）。',
  },
  module_spacer: {
    title: '空白间隔模块',
    purpose: '在模块之间插入纯空白区域，调整页面视觉节奏和留白。',
    usage: '拖动滑块设置高度（4–80px），不产生可见内容，仅增加垂直间距。',
  },
  module_rating: {
    title: '评星模块',
    purpose: '第二页核心模块：买家评分后自动上报；5 星及以上引导跳转亚马逊留评链接。',
    usage: '第二页默认包含且不可删除。留评链接在「页面信息 → 留评链接」配置。各文案留空则使用默认多语言文案。',
    tips: '低分（4 星及以下）仅显示感谢语，不引导留评，避免负面评价公开化。',
  },

  // ── 页面模块通用 ──
  block_margin: {
    title: '模块间距',
    purpose: '控制当前模块与上下模块之间的垂直间距。',
    usage: '拖动滑块调整 0–60px。数值越大，模块之间空隙越大。',
    tips: '自定义 HTML 整页模块无间距设置（整页直出）。',
  },

  // ── 标题模块 ──
  block_heading_text: {
    title: '标题文字',
    purpose: '落地页上显示的主标题或副标题内容。',
    usage: '按当前语言填写。支持单行文字。',
  },
  block_heading_align: {
    title: '标题对齐',
    purpose: '标题在页面中的水平对齐方式。',
    usage: '可选居中、左对齐、右对齐。',
  },
  block_heading_color: {
    title: '标题颜色',
    purpose: '标题文字的颜色。',
    usage: '使用取色器选择，默认深色 #111111。',
  },

  // ── 段落模块 ──
  block_text_text: {
    title: '段落文字',
    purpose: '落地页上的说明段落、产品介绍等正文内容。',
    usage: '支持多行文本，按当前语言分别编辑。',
  },
  block_text_align: {
    title: '段落对齐',
    purpose: '段落文字的水平对齐方式。',
    usage: '可选居中、左对齐、右对齐。',
  },

  // ── 图片模块 ──
  block_image_upload: {
    title: '上传图片',
    purpose: '从本地上传图片到服务器，用于落地页展示。',
    usage: '支持 JPEG、PNG、WebP、GIF。上传成功后自动填入图片地址。',
  },
  block_image_url: {
    title: '图片 URL',
    purpose: '通过外链地址引用图片，无需上传。',
    usage: '填写以 https:// 开头的完整图片地址。与上传二选一即可。',
  },
  block_image_link: {
    title: '点击跳转链接',
    purpose: '买家点击图片时跳转的目标 URL。',
    usage: '可选。留空则图片不可点击。可链接到产品页、官网等。',
  },
  block_image_width: {
    title: '图片最大宽度',
    purpose: '限制图片显示的最大宽度（像素），防止过大撑破布局。',
    usage: '留空为自动适应容器宽度。',
  },
  block_image_radius: {
    title: '图片圆角',
    purpose: '图片四角的圆角半径（像素）。',
    usage: '0 为直角，数值越大越圆润。',
  },

  // ── 横幅模块 ──
  block_banner_upload: {
    title: '上传横幅图',
    purpose: '上传全宽横幅大图，通常放在页面顶部。',
    usage: '支持常见图片格式。横幅会以 cover 方式铺满宽度。',
  },
  block_banner_url: {
    title: '横幅图片 URL',
    purpose: '通过外链引用横幅图片。',
    usage: '填写完整图片地址，建议横向比例（如 16:9）。',
  },
  block_banner_link: {
    title: '横幅跳转链接',
    purpose: '点击横幅时跳转的 URL。',
    usage: '可选。常用于链向亚马逊产品页或官网。',
  },

  // ── 订阅表单模块 ──
  block_form_name_placeholder: {
    title: '姓名占位符',
    purpose: '姓名输入框内显示的提示文字。',
    usage: '如 "Your Name"。按语言填写对应翻译。',
  },
  block_form_email_placeholder: {
    title: '邮箱占位符',
    purpose: '邮箱输入框内显示的提示文字。',
    usage: '如 "Email Address"。',
  },
  block_form_subscribe_label: {
    title: '订阅勾选文案',
    purpose: '同意订阅/营销授权的勾选框旁显示的文字。',
    usage: '如 "I agree to subscribe to updates"。需符合当地隐私法规表述。',
  },
  block_form_confirm_button: {
    title: '确认按钮文字',
    purpose: '提交订阅表单的按钮文字。',
    usage: '如 "Confirm" 或 "Subscribe"。',
  },
  block_form_btn_color: {
    title: '按钮颜色',
    purpose: '提交按钮的背景色。',
    usage: '默认蓝色 #2563eb，建议与品牌色一致。',
  },
  block_form_btn_text_color: {
    title: '按钮字色',
    purpose: '提交按钮上文字的颜色。',
    usage: '默认白色 #ffffff，需与背景色有足够对比度。',
  },
  block_form_open_mail_app: {
    title: '提交后自动打开邮箱 App',
    purpose: '买家提交成功后 3 秒，自动唤起手机邮箱 App 并预填验证码邮件。',
    usage: '需先在「页面信息」配置客服邮箱。配合「其他配置」中的邮箱 App 文案使用。',
    tips: '大幅提升移动端建联转化率，建议在主要面向手机扫码的场景开启。',
  },

  // ── 联系按钮模块 ──
  block_buttons_show_email: {
    title: '显示邮件联系按钮',
    purpose: '在落地页展示「邮件联系」按钮，买家点击即可打开邮箱 App。',
    usage: '需配置客服邮箱。按钮会自动填入收件人和验证码相关内容。',
  },
  block_buttons_email_button: {
    title: '邮件按钮文字',
    purpose: '邮件联系按钮上显示的文字。',
    usage: '如 "Email Us" 或 "联系我们"。',
  },
  block_buttons_email_style: {
    title: '邮件按钮样式',
    purpose: '邮件按钮的背景色、边框色和文字颜色。',
    usage: '分别设置背景、边框、字色，打造与页面风格一致的按钮。',
  },
  block_buttons_whatsapp: {
    title: 'WhatsApp 号码',
    purpose: '展示 WhatsApp 联系按钮，买家点击直接发起对话。',
    usage: '格式：国家码+号码，无加号，如 8613800138000。留空则不显示 WhatsApp 按钮。',
  },
  block_buttons_wa_style: {
    title: 'WhatsApp 按钮样式',
    purpose: 'WhatsApp 按钮的背景色、边框色和文字颜色。',
    usage: '默认绿色系。可自定义以匹配页面设计。',
  },

  // ── 视频模块 ──
  block_video_youtube_url: {
    title: 'YouTube 链接',
    purpose: '在落地页嵌入 YouTube 视频播放器。',
    usage: '支持 youtu.be 短链或 youtube.com/watch?v= 完整链接。粘贴后预览可查看效果。',
  },

  // ── FAQ 模块 ──
  block_faq_title: {
    title: 'FAQ 标题',
    purpose: '常见问题区块的标题文字。',
    usage: '如 "FAQ" 或 "Frequently Asked Questions"。',
  },
  block_faq_items: {
    title: '问答列表',
    purpose: '常见问题和对应回答，以折叠或列表形式展示。',
    usage: '点击「+ 添加」新增问答对。按当前语言分别填写问题和回答。',
  },

  // ── 富文本 / 自定义 HTML ──
  block_richtext_html: {
    title: 'HTML 内容',
    purpose: '自定义 HTML 片段或整页内容，实现高度自由的页面布局。',
    usage: '支持标准 HTML 标签。可使用「AI 提示词助手」生成对接后端的代码。richtext_full 类型会整页直出，跳过其他模块。',
    tips: '注意移动端适配，避免使用过宽的固定像素布局。',
  },

  // ── 社交媒体模块 ──
  block_social_links: {
    title: '社交链接',
    purpose: '展示品牌社交媒体图标和链接。',
    usage: '选择平台（Facebook、Instagram、X 等）并填写对应主页 URL。可添加多条。',
  },

  // ── 分割线模块 ──
  block_divider_height: {
    title: '分割线粗细',
    purpose: '水平分割线的粗细（像素）。',
    usage: '拖动滑块 1–10px。用于分隔不同内容区块。',
  },
  block_divider_color: {
    title: '分割线颜色',
    purpose: '分割线的颜色。',
    usage: '默认浅灰 #e5e7eb。',
  },
  block_divider_style: {
    title: '分割线样式',
    purpose: '分割线的线型。',
    usage: '可选实线、虚线、点线。',
  },

  // ── 空白间隔模块 ──
  block_spacer_height: {
    title: '空白高度',
    purpose: '在模块之间插入纯空白区域，调整视觉节奏。',
    usage: '拖动滑块 4–80px。不产生可见内容，仅增加垂直间距。',
  },

  // ── 评星模块（第二页）──
  block_rating: {
    title: '星级评分模块',
    purpose: '第二页核心模块：买家评分后自动上报；5 星及以上引导跳转亚马逊留评链接。',
    usage: '留评链接在「页面信息 → 留评链接」配置。各文案留空则使用默认多语言文案。',
  },
  block_rating_activate_title: {
    title: '激活标题',
    purpose: '买家进入第二页时显示的标题，表示建联/激活成功。',
    usage: '如 "Activation Successful"。',
  },
  block_rating_rate_prompt: {
    title: '评分提示',
    purpose: '引导买家进行星级评分的提示语。',
    usage: '如 "How would you rate our product?"',
  },
  block_rating_review_prompt: {
    title: '5 星感谢语',
    purpose: '买家给出 5 星后显示的感谢文字。',
    usage: '可引导其前往亚马逊留评。',
  },
  block_rating_review_button: {
    title: '留评按钮',
    purpose: '5 星后显示的留评按钮文字。',
    usage: '点击跳转至「留评链接」配置的亚马逊地址。',
  },
  block_rating_low_rate_prompt: {
    title: '低分感谢语',
    purpose: '买家给出 4 星及以下时显示的感谢/安抚文字。',
    usage: '不引导留评，仅收集反馈。如 "Thank you for your feedback."',
  },
  block_rating_countdown_text: {
    title: '倒计时文案',
    purpose: '5 星后自动跳转留评链接前的倒计时提示。',
    usage: '使用 {n} 表示剩余秒数。如 "Redirecting in {n}s..."',
  },

  // ── Logo 模块 ──
  block_logo: {
    title: 'Logo 模块',
    purpose: '在落地页展示品牌 Logo。',
    usage: 'Logo 图片需在页面信息中配置品牌 Logo（当前 PRO 页面级暂未开放上传入口，模块为占位提示）。',
    tips: '后续版本可能开放页面级 Logo 上传。',
  },
}

export function getHelpContent(key) {
  return QR_PRO_HELP[key] || null
}
